export default __webpack_public_path__ + "static/media/PDF-documentation.c03c4392.md";